export enum ReviewStatus {
  Pending,
  Reviewed
}
